__turbopack_context__.v({
  "delta": "TYudFq_delta",
  "deltaFloat": "TYudFq_deltaFloat",
  "highlight": "TYudFq_highlight",
  "metricPulse": "TYudFq_metricPulse",
  "wrapper": "TYudFq_wrapper",
});
